module.exports = __webpack_public_path__ + "img/confirmation-success.89ba19ac.svg";